import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import Projects from '../../components/projects/Projects';
import { ReactComponent as LikesLogo } from '../../assets/images/svg/likesLogo.svg';
import './LikedProjects.css';
import GlobalOrganizationsProjects from '../../components/global/GlobalOrganizationsProjects';
import { setAllProjects, setDisplayProjects } from '../../services/store/GenericReducer';
import { sortProjectsByDisplayOrder } from '../../services/filters/filters';

export default function LikedProjects(props) {

    const store = useSelector(state => state.reducer);
    const dispatch = useDispatch();
    const [likedProjects, setLikedProjects] = useState([]);
    const [allProjectsLocal, setAllProjectsLocal] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    // Fetch projects if store is empty
    useEffect(() => {
        const fetchProjects = async () => {
            if (store.allProjects?.length > 0) return;

            setIsLoading(true);
            try {
                const organizationsProjects = await GlobalOrganizationsProjects();
                const projects = organizationsProjects.projects || [];
                if (projects.length > 0) {
                    dispatch(setAllProjects(projects));
                    const sortedProjects = sortProjectsByDisplayOrder(projects);
                    dispatch(setDisplayProjects(sortedProjects));
                    setAllProjectsLocal(projects);
                }
            } catch (error) {
                console.error('Error fetching projects:', error);
            }
            setIsLoading(false);
        };

        fetchProjects();
    }, [store.allProjects, dispatch]);

    // Get projects from store or local state
    const availableProjects = store.allProjects?.length > 0 ? store.allProjects : allProjectsLocal;

    useEffect(() => {
        // Get liked project IDs from localStorage
        const likedIds = JSON.parse(localStorage.getItem('likedProjects')) || [];

        // Filter allProjects to get only liked ones
        if (availableProjects.length > 0) {
            const liked = availableProjects.filter(project =>
                likedIds.includes(project._id)
            );
            setLikedProjects(liked);
        }
    }, [availableProjects]);

    // Listen for likes changes (when user likes/unlikes on this page or others)
    useEffect(() => {
        const handleLikesChange = () => {
            const likedIds = JSON.parse(localStorage.getItem('likedProjects')) || [];
            if (availableProjects.length > 0) {
                const liked = availableProjects.filter(project =>
                    likedIds.includes(project._id)
                );
                setLikedProjects(liked);
            }
        };

        window.addEventListener('likedProjectsUpdated', handleLikesChange);
        return () => window.removeEventListener('likedProjectsUpdated', handleLikesChange);
    }, [availableProjects]);

    return (
        <section className="liked-projects-section">
            <div className="liked-projects-header">
                <LikesLogo className="likes-logo"/>
                <h1>התנדבויות שמעניינות אותי</h1>
            </div>

            {likedProjects.length === 0 ? (
                // Mode 1: No liked projects
                <div className="liked-projects-empty">
                    <div className="empty-message">
                        <p className="empty-title">עוד לא בחרת התנדבות?</p>
                        <p className="empty-subtitle">זה בדיוק הזמן להתחיל להתנדב!</p>
                    </div>
                    <Link to={`/`} className="btn-search-projects">
                        חיפוש אפשרויות התנדבות
                    </Link>
                </div>
            ) : (
                // Mode 2: Show liked projects - Uses Projects component which already has cards-slider structure
                <Projects
                    partner={props.partner}
                    leadingColor={props.partner?.partnerConfig?.leadingColor}
                    projects={likedProjects}
                />
            )}
        </section>
    );
}
